import { makeStyles } from '@material-ui/core';

export const usePlanTypeSectionStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
  },
  switcher: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },
  switcherText: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    whiteSpace: 'nowrap',
  },
  createTemplateButton: {
    height: '40px',
    minWidth: 'unset',
    padding: '12px 20px',
    borderRadius: '100px',
    color: theme.palette.colors.bluePrimaryMain,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.32px',
    textTransform: 'none',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(15, 72, 184, 0.04)',
      boxShadow: 'none',
    },
  },
}));
